export default "__VITE_ASSET__CSDthAbu__"